import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import PopupMenuButton from '../../../gd-components/popover-menu/popup-menu-button/popup-menu-button'
import AggregateMoreMenu from './aggregate-more/aggregate-more-menu'

export type AggregateShellProps = {
    className?                  : string

    noData?                     : boolean
    hint?                       : string

    options                     : any[],            //available aggregate functions array

    type                        : 'list' | 'table' | 'gantt' | 't-list'
    aggregateFunction           : string

    isFirstInBlock              : boolean
    isLastInBlock               : boolean

    onChangeAggregateFunction   : callback          //for more button

    children?                   : any
}

export default class AggregateShellComponent extends React.Component<AggregateShellProps> {

    static propTypes = {
        options: PropTypes.array,              //available aggregate functions array

        type: PropTypes.oneOf(['list','table','gantt','t-list']),
        aggregateFunction: PropTypes.string,

        isFirstInBlock: PropTypes.bool,
        isLastInBlock: PropTypes.bool,

        onChangeAggregateFunction: PropTypes.func //for more button
    }

    state = {
        showPopover: false,
        useHint: false
    }

    componentDidMount() {
        this._checkHintUsage();
    }

    componentDidUpdate() {
        this._checkHintUsage();
    }

    _checkHintUsage = () => {
        const node:any = findDOMNode(this);
        const useHint = node && node.clientWidth < node.scrollWidth

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    };

    onTogglePopover = (value:boolean) => {
        this.setState({showPopover:value});
    }

    render() {
        const classes = Classes("aggregate", this.props.type, this.props.className, {
            'has-aggregate-function'    : !!this.props.aggregateFunction,
            'no-aggregate-function'     : !this.props.aggregateFunction,
            'show-popover'              : this.state.showPopover,
            'no-aggregate-value'        : this.props.noData,
        });

        return (
            <div className={classes}>

                {!!this.props.aggregateFunction && this.props.children}

                <PopupMenuButton className="aggregate-more ui5-ico-aggregate-fx"
                                 menuComponent={AggregateMoreMenu}
                                 menuParams={{
                                     options: this.props.options,
                                     aggregateFunction: this.props.aggregateFunction,
                                     onClickOption: this.props.onChangeAggregateFunction
                                 }}
                                 onTogglePopover={this.onTogglePopover}/>

                {!this.props.noData && this.state.useHint && <HintPopover parent={this} hint={this.props.hint?.toString()} multiline={true} showDelay={500}/>}
            </div>
        );
    }
}